import { Box, CircularProgress } from '@mui/material';

import Autocomplete from 'shared/components/widgets/autocomplete';
import Input from 'shared/components/widgets/input';

import Button from 'shared/components/widgets/button';
import { Controller, useForm } from 'react-hook-form';
import AutocompleteContainer from 'shared/components/widgets/autocomplete-container';
import { fileStatusDropdownList } from 'constants/dropdown/customer-delivery/file-status';
import FileRegisterButton from '@components/file-management/file-management-list/file-register-button.tsx';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { isAdmin } from '@utils/getRole.ts';

const CustomerDeliveryFilesFilter = ({ getFilteredList, isCreateAction, createActionPath, isLoading }) => {
  const location = useLocation()
  const isRefresh = location?.state?.refresh
  const { control, handleSubmit, watch, setValue } = useForm({
    defaultValues: {
      schOtmSt: 'all',
      schGroup: 'subject',
      schKeyword: '',
    },
  });

  useEffect(() => {
    if (isRefresh) {
      setValue('schOtmSt', 'all')
      setValue('schGroup', 'subject')
      setValue('schKeyword', '')
    }
  }, [isRefresh])

  const keyword = watch('schKeyword');

  const onSubmit = (data) => {
    const { schOtmSt, schKeyword } = data;
    getFilteredList([
      { key: 'page', value: 1 },
      {
        key: 'schOtmSt',
        value: schOtmSt === 'all' ? '' : schOtmSt,
      },
      { key: 'schGroup', value: 'subject_filename' },
      { key: 'schKeyword', value: schKeyword },
    ]);
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      display="flex"
      flexDirection="row"
      alignItems="flex-end"
      gap={2}
      marginBottom="40px"
    >
      {/* FILE STATUS */}
      <AutocompleteContainer>
        <Controller
          name="schOtmSt"
          control={control}
          render={({ field }) => {
            return (
              <Autocomplete
                title="파일상태"
                options={fileStatusDropdownList}
                defaultValue={
                  fileStatusDropdownList.find(
                    (el) => el.value === field.value,
                  ) ?? {
                    label: '전체',
                    value: 'all',
                  }
                }
                value={field?.value ?? 'all'}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                onChange={(_, newValue, reason) => {
                  field.onChange(newValue?.value);
                  if (reason === 'clear') {
                    field.onChange('all');
                  }
                }}
              />
            );
          }}
        />
      </AutocompleteContainer>

      <Box sx={{ maxWidth: '300px' }} flex={1}>
        <Controller
          name="schKeyword"
          control={control}
          render={({ field }) => {
            return (
              <Input
                {...field}
                isSearch
                keyword={keyword}
                placeholder="검색어를 입력해 주세요."
                clearAction={() => {
                  field.onChange('');
                }}
                value={field.value}
                showErrorMsg={false}
                sx={{ width: '100%' }}
              />
            );
          }}
        />
      </Box>
      <Button
        disabled={isLoading}
        variant="outlined"
        type="submit"
        sx={{ minWidth: '120px' }}>
        {isLoading ?
          <CircularProgress size={20} color='secondary' />
          :
          '검색하기'
        }
      </Button>

      {(!isAdmin &&
        <FileRegisterButton isCreateAction={isCreateAction} createActionPath={createActionPath} />
      )}
    </Box>
  );
};

export default CustomerDeliveryFilesFilter;
